  <template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label-width="0px">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="5">
                      <el-select v-model="form.dtType">
                        <el-option
                            v-for="item in combos['dtType']"
                            :key="item.value"
                            :value="item.key"
                            :label="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="9">
                      <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: start;">-</el-col>
                    <el-col :span="9">
                      <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-form-item label="진행상태" label-width="100px">
                  <el-col :span="12">
                    <el-select v-model="form.asStatus" @change="onAsStatusChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['asStatus']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <el-select v-model="form.searchSubAsStatus" v-show="changeAsStatusShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['searchSubAsStatus']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="7">
              <el-row>
                <el-form-item label="접수유형" label-width="100px">
                  <el-col :span="12">
                    <el-select v-model="form.asClass" @change="onAsClassChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['asClass']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <el-select v-model="form.searchSubAsClass" v-show="changeAsClassShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['searchSubAsClass']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>

          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="처리기사" label-width="80px">
                <el-select v-model="form.userId">
                  <el-option
                      v-for="item in combos['userId']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked" />
          </div>
          <div class="grid-tbl-box" v-show="false">
            <ag-grid-vue
                ref="excelGrid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="excelColumnDefs"
                :grid-options="excelGridOptions"
                :row-data="excelData"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadyExcel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal from "@/components/AS/CallTreat/Modal/ReceptionModal";

import mixin from "@/mixin/lucoms";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
  return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
  props: {
  },
  mixins: [mixin],
  data() {
    return {
      data: [],
      excelData: [],
      form: {
        companyId : '',
        dtType : 'CALL_DT',
        startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        asClass : '',
        searchSubAsClass : '',
        asStatus : '',
        searchSubAsStatus : '',
        userId : '',
        asAgentId : '',
        whereString : '',
        sortType : '',
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'asStatus' : [],
        'subAsStatus' : [],
        'searchSubAsStatus' : [],
        'asClass' : [],
        'subAsClass' : [],
        'searchSubAsClass' : [],
        'userId' : [],
        'custType' : [],
        'dtType' : []
      },
      //startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
      //endDt: this.$moment().format('YYYY-MM-DD'),
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 40px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      excelColumnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      changeAsStatusShow : false,
      changeAsClassShow : false,
      userIdShow : false
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'접수일자', field:'callDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'접수유형', field:'asClassNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'modelGroupNm', width:210, cellStyle:{textAlign: 'center'}},
        {headerName:'모델', field:'modelNm', width:210, cellStyle:{textAlign: 'center'}},
        {headerName:'고객구분', field:'custTypeNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트명', field:'siteNm', width:250 },
        {headerName:'주소', field:'addr', width:350, cellStyle:{textAlign: 'left'}},
        {headerName:'신고자명', field:'asBoundCustNm', width:110, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }},
        {headerName:'연락처', field:'telNo', width:150, cellStyle:{textAlign: 'center'}},
        {headerName: '핸드폰', width:120, field:'hpNo', cellStyle:{textAlign: 'center'}},
        {headerName:'요청일시', field:'requestVisitDt', width:120, cellStyle:{textAlign: 'center'},
        cellRenderer: (params) => {
          return params.value = params.value === null  ? '' : this.$moment(`${params.value}`).format('YYYY-MM-DD HH:mm:ss') ;
        }},
        {headerName:'처리기사', field:'userNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'진행상태', field:'asStatusNm', cellStyle:{textAlign: 'center'}, width:160}
      ];
    },
    createExcelColumnDefs() {
      const that = this;
      this.excelColumnDefs = [
        {headerName:'접수일자', field:'callDt', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'접수유형', field:'asClass', width:130, cellStyle:{textAlign: 'center'}},
        {headerName:'고객구분', field:'custType', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트명', field:'siteNm1', width:200, cellStyle:{textAlign: 'center'}},
        {headerName:'주소', field:'addr1', width:250, cellStyle:{textAlign: 'center'}},
        {headerName:'신고자명', field:'boundCustNm', width:130, cellStyle:{textAlign: 'center'}},
        {headerName:'연락처', field:'telNo', width:110, cellStyle:{textAlign: 'left'}},
        {headerName:'핸드폰', field:'hpNo', width:110},
        {headerName:'요청일시', field:'requestVisitDt', width:250},
        {headerName:'처리기사', field:'userNm', width:110},
        {headerName:'진행상태', field:'asStatus', width:130}
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      if(field === 'asBoundCustNm') {
        this.openModel(params.data);
      }
    },
    /**
     * 접수/처리 상세 팝업 오픈
     */
    openModel(param) {
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ReceptionModal,
        parent: this,
        props: {
          data: {
            asId: param.asId,
            custId: param.custId,
            firstTab: 'INIT1', /** 첫번째 TAB FLAG : 접수내역 */
            sortType: '',
            popHeadInfo: {}, //this.custParam.popHeadInfo,
            //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
            recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
            procsDt: this.$moment(param.procDt).format('YYYY-MM-DD')
          }
        },
        events: {
          close(data) {
            console.log('close', data);
          },
        }
      });
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      let that = this

      this.$store.commit('loading')

      let vForm = {
        companyId : this.form.companyId,
        dtType : this.form.dtType,
        startDt: this.form.startDt || '1900-01-01',
        endDt : this.form.endDt || '2100-12-31',
        asClass : (this.form.searchSubAsClass.length <= 0 || this.form.searchSubAsClass === '') ? (this.form.asClass === '' ? 0 : this.form.asClass) : this.form.searchSubAsClass,
        asStatus : (this.form.searchSubAsStatus.length <= 0 || this.form.searchSubAsStatus === '') ? (this.form.asStatus === '' ? 0 : this.form.asStatus) : this.form.searchSubAsStatus,
        userId : this.form.userId === '' ? 0 : this.form.userId,
        asAgentId : this.form.asAgentId,
        whereString : this.form.whereString,
        sortType : this.form.sortType,
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }

      this.$http.post(_url("/api/agent/asCall/list"), vForm).then(response => {
        this.data = response.data.map(x => {
          x.siteNm = (x.siteNm1 || '') + ' ' + (x.siteNm2 || '') + ' ' + (x.siteNm3 || '')
          x.addr = x.addr1 + ' ' + x.addr2;
          return x

        })
        /* data customize */
        this.changeData();
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/agent/asCall/init`)
          .then(response => {
            this.combos['asStatus'] = response.data.asStatus;                   // AS진행상태
            this.combos['subAsStatus'] = response.data.subAsStatus;             // AS진행상태(sub)
            this.combos['asClass'] = response.data.asClass;                     // 접수유형
            this.combos['subAsClass'] = response.data.subAsClass;               // 접수유형(sub)
            this.combos['searchSubAsStatus'] = response.data.searchSubAsStatus; // 접수유형(sub) - 조회조건
            this.combos['custType'] = response.data.custType;                   // 고객구분
            this.combos['dtType'] = response.data.dtType;                       // 검색구분
          }).finally(() => {
            this.agentInfo();
            //this.isAuth();
            this.goOpen();
            this.$store.commit('finish');
          });

      this.createMainColumnDefs();
      this.createExcelColumnDefs();
    },
    agentInfo(){
      this.$store.commit('loading')
      this.$http.post("/api/asAgentMng/detail/agent", {
            companyId: this.$store.state.loginInfo.compCd,
            asAgentId: this.$store.state.loginInfo.asAgentId,
            userId : 0,
            useYn : 'Y',
            processTime: ""
          }).then(response => {
            this.combos['userId'] = response.data.map(x => {
              x.key = x.userId
              x.value = x.userNm
              return x
            });
            this.combos['userId'].unshift({key:'', value:'전체'})

            //센터관리자, admin 권한이 아닌경우
            if( ![6, 1, 2].includes(parseInt(this.$store.state.loginInfo.groupUId))){
              this.combos['userId'] = this.combos['userId'].filter(f => parseInt(f.userId) === parseInt(this.$store.state.loginInfo.id))
            }
          }).finally(() => {
            this.form.userId = this.combos['userId'][0].key
            this.$store.commit('finish')
      });
    },
    onAsStatusChange(param){
      this.form.searchSubAsStatus = '';
      if(param === 'Suspension') this.changeAsStatusShow =  true;
      else{
        this.changeAsStatusShow =  false;
      }
    },
    onAsClassChange(param){
      this.form.searchSubAsClass = '';
      if(param === '') this.changeAsClassShow =  false;
      else{
        this.changeAsClassShow =  true;
        this.$http.get(`/api/codeMng/detail`, { params: {topKey: 'AsClass'} })
            .then(response => {
              let vCatId = response.data.filter(y => y.catKey === param)[0].catId;
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: vCatId} })
                  .then(response => {
                    this.combos['searchSubAsClass'] = response.data || []
                  });
            });
      }
    },
    /* data customize */
    changeData(){
      this.data.map((x, i) => {
          let filterAsStatus = this.combos['subAsStatus'].filter(y => y.key === x.asStatus);
          x.asStatusNm = filterAsStatus[0]?.value;
          let filterAsClass = this.combos['subAsClass'].filter(y => y.key === x.asClass);
          x.asClassNm = filterAsClass[0]?.value;
          let filterCustType = this.combos['custType'].filter(y => y.key === x.custType);
          x.custTypeNm = filterCustType[0]?.value;
      })
    },
    isAuth(){
      this.auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===189);
    },
    excelDown() {

      const vForm = {
        companyId : this.form.companyId,
        dtType: this.form.dtType,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        asClass: this.form.asClass,
        asStatus: this.form.asStatus,
        userId: this.$store.state.loginInfo.id,
        asAgentId: this.$store.state.loginInfo.asAgentId,
        sortType: this.form.sortType,
        processTime: ''
      }

      this.$store.commit('loading')
      this.$http.post(_url("/api/agent/asCall/saveExcel"), vForm)
          .then(response => {
            this.excelData = response.data.map(x => {

              let filterAsStatus = this.combos['subAsStatus'].filter(y => y.key === x.asStatus);
              x.asStatus = filterAsStatus[0]?.value;

              let filterAsClass = this.combos['subAsClass'].filter(y => y.key === x.asClass);
              x.asClass = filterAsClass[0]?.value

              let filterCustType = this.combos['custType'].filter(y => y.key === x.custType);
              x.custType = filterCustType[0]?.value

              x.callDt = x.callDt !== null ? this.$moment(x.callDt).format('YYYY-MM-DD') : ''
              x.siteNm1 = x.siteNm1 !== null ? x.siteNm1 + ' ' + x.siteNm2 + ' ' + x.siteNm3 : ''
              x.addr1 = x.addr1 !== null ? x.addr1 + ' ' + x.addr2 : ''
              x.requestVisitDt = x.requestVisitDt !== null ? this.$moment(x.requestVisitDt).format('YYYY-MM-DD HH:mm') : ''
              x.telNo = _phone(x.telNo) || '';
              x.hpNo = _phone(x.hpNo) || '';

              return x;
            })
            console.log('>> ', response.data)
          }).finally(() => {
            this.$store.commit('finish');
            var params = {
              fileName : "AS미처리리스트"
            };
          this.excelGridOptions.api.exportDataAsExcel(params);
      });

    }
  },
  created() {

    if(this.$route.query.startDt == 'TodayComplete'){
      this.form.startDt = this.$moment().format('YYYY-MM-DD');
    }else if(this.$route.query.startDt == 'TodayWork'){
      this.form.startDt = '';
      this.form.whereString = "AND B.AS_STATUS NOT IN ('Complete', 'Confirm', 'Square')";

    }

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
    this.form.asAgentId = this.$store.state.loginInfo.asAgentId;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>